import React, { useState, useEffect } from "react";

import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import MDBadge from "components/MDBadge";

import Moment from "react-moment";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import DataTable from "examples/Tables/DataTable";
import { statusColor } from "../../../config/enum";

import { getRef } from "../../../api/refs";

import CreateEditRefs from "../CreateEditRefs";

// Material Dashboard 2 PRO React contexts
import { useMaterialUIController } from "context";

import { useSelector } from "react-redux";
import { canEditOrder } from "../../../utils/permissions";

export default function RefTable({ device, user }) {
  const currentOrder = useSelector((state) => state.orders.currentOrder);
  const canEdit = canEditOrder(user, currentOrder);
  const [refs, setRefs] = useState([]);
  const [refRows, setRefRows] = useState([]);

  const refColumns = [
    { Header: "Fournisseur", accessor: "supplier", align: "center" },
    { Header: "Modèle", accessor: "model", align: "center" },
  ];

  async function fetchRefs() {
    const response = await getRef(device.device_id);
    setRefs(response.data);
  }

  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  useEffect(() => {
    fetchRefs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setRefRows(generateRows);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refs, darkMode]);

  function generateRows() {
    const rows = [];
    for (let i = 0; i < refs.length; i++) {
      rows.push({
        supplier: (
          <MDTypography component="a" variant="button" fontWeight="medium">
            {refs[i].supplier_name === null ? "inconnu" : refs[i].supplier_name}
          </MDTypography>
        ),
        model: (
          <>
            <MDTypography component="a" variant="button" fontWeight="medium">
              {refs[i].model_name === null ? "inconnu" : refs[i].model_name}
            </MDTypography>
            <MDBox mt={-0.5}>
              {refs[i].ref === null ? (
                <>
                  <MDTypography component="span" sx={{ fontWeight: "800" }} variant="button">
                    réf:{" "}
                    <MDTypography component="a" sx={{ fontWeight: "400" }} variant="button">
                      inconnu
                    </MDTypography>
                  </MDTypography>
                </>
              ) : (
                <>
                  <MDTypography component="span" sx={{ fontWeight: "800" }} variant="button">
                    réf:{" "}
                    <MDTypography component="span" sx={{ fontWeight: "400" }} variant="button">
                      {refs[i].ref}
                    </MDTypography>
                  </MDTypography>
                </>
              )}
            </MDBox>
          </>
        ),
      });
    }
    return rows;
  }
  return (
    <Grid item xs={12}>
      <Card sx={{ height: "100%" }}>
        <MDBox
          mx={2}
          mt={-3}
          py={1.5}
          px={2}
          variant="gradient"
          borderRadius="lg"
          sx={{
            background: !darkMode ? "linear-gradient(195deg, #364c70, #273956)" : "white",
            boxShadow: darkMode ? "0 1px 4px 1px white" : "0 1px 4px 1px #344767",
            display: "flex",
            verticalAlign: "middle",
          }}
        >
          <Grid sx={{ width: "60%" }}>
            <MDTypography
              variant="h5"
              sx={{
                lineHeight: "2.4rem",
                display: "tableCell",
                verticalAlign: "middle",
              }}
              color={darkMode ? "inherit" : "white"}
            >
              Fournisseurs
            </MDTypography>
          </Grid>
          {canEdit && (
              <Grid sx={{ textAlign: "right", width: "40%" }}>
                {refs.length < 10 && (
                  <CreateEditRefs edit={false} device={device} refs={refs} setRefs={setRefs} />
                )}
                {refs.length > 0 && (
                  <CreateEditRefs edit device={device} refs={refs} setRefs={setRefs} />
                )}
              </Grid>
            )}
        </MDBox>

        {refRows && refRows.length === 0 ? (
          <MDBox
            px={1}
            sx={{ textAlign: "center", paddingTop: 3, paddingBottom: 2, height: "100%" }}
          >
            <MDTypography
              component="a"
              variant="h5"
              color={darkMode ? "white" : "inherit"}
              style={{
                display: "tableCell",
                verticalAlign: "middle",
              }}
            >
              Aucun fournisseur n'a encore été ajouté
            </MDTypography>
          </MDBox>
        ) : (
          <MDBox
            pt={0.75}
            sx={{
              height: "100%",
              "div.MuiTableContainer-root": {
                height: "100%",
                display: "flex",
              },
            }}
          >
            <DataTable
              size="medium"
              table={{ columns: refColumns, rows: refRows }}
              isSorted={false}
              entriesPerPage={false}
              showTotalEntries={false}
              noEndBorder
            />
          </MDBox>
        )}
      </Card>
    </Grid>
  );
}
